// Accordion1.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Accordion1({ handleDialogClose4 }){

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const bookList = useSelector((state) => state.home.bookList);
    const book4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.book4Accordion1);
    const chapter4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.chapter4Accordion1);
    const verse4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.verse4Accordion1);
    const bookChapter2 = useSelector((state) => state.noteBookmarkVerseList.bookChapter2);
    const bookChapterList2 = useSelector((state) => state.noteBookmarkVerseList.bookChapterList2);
    const verseList4Accordion1 = useSelector((state) => state.noteBookmarkVerseList.verseList4Accordion1);
    const noteBookmarkVerseList = useSelector((state) => state.noteBookmarkVerseList.noteBookmarkVerseList);
    const loading4Home = useSelector((state) => state.home.loading4Home);
    //const credential = useSelector((state) => state.signIn.credential);

    const handleOnClickVerseAdd = (book, chapter, verse, details) => {
        const exists = noteBookmarkVerseList.some(noteBookmarkVerseListItem => noteBookmarkVerseListItem.book === book && noteBookmarkVerseListItem.chapter === chapter && noteBookmarkVerseListItem.verse === verse);
        if (!exists) {
            let list = [...noteBookmarkVerseList, {book: book, chapter: chapter, verse: verse, details: details}]
            list.sort((a, b) => {
                return (
                    a.book - b.book ||
                    a.chapter - b.chapter ||
                    a.verse - b.verse
                );
            });
            dispatch(setNoteBookmarkVerseList(list));
        }
    };

    const book4SetBookChapter2 = (book) => {
        if (book === 0) {
        dispatch(setBookChapter2({ book: 0, chapter: 0 }));
        } else {
        dispatch(setBookChapter2({ book: book, chapter: 1 }));
        }  
    }

    const chapter4SetBookChapter2 = (e) => {
        dispatch(setBookChapter2({ ...bookChapter2, chapter: e }));
    };

    const handleOnChangeVerse = (e) => {
        let value = e.target.value;
        dispatch(setVerse4Accordion1(value));
    };

    const handleOnChangeChapter = (e) => {
        let value = e.target.value;
        dispatch(setChapter4Accordion1(value));
        dispatch(setVerse4Accordion1(1));
        chapter4SetBookChapter2(value);
    };

    const handleOnChangeBook = (e) => {
        let value = e.target.value;
        dispatch(setBook4Accordion1(value));
        if (value === 0) {
            dispatch(setChapter4Accordion1(0));
            dispatch(setVerse4Accordion1(0));
        } else {
            dispatch(setChapter4Accordion1(1));
            dispatch(setVerse4Accordion1(1));
        }        
        book4SetBookChapter2(value);  
    };

    useEffect(() => {
        if (book4Accordion1 !== 0) getVerseList4Accordion1('Accordion1');
    }, [book4Accordion1, chapter4Accordion1]);

    useEffect(() => {
        if (book4Accordion1 !== 0){
        const list = [];
        for (let i = 1; i <= bookList[book4Accordion1-1].Chapters; i++) {
            list.push({ book: book4Accordion1, chapter: i });
        }
        dispatch(setBookChapterList2(list));
        }
    }, [book4Accordion1]);

    return (

        <Accordion sx={{ color: 'white', backgroundColor: 'warning.light', borderRadius: 1 }} fullWidth>

            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            >                
                <Typography gutterBottom variant="body2" component="div">
                    新增經文
                </Typography>                
            </AccordionSummary>

            <AccordionDetails>

                {/* <Grid container spacing={1}> */}

                    <Grid size={12}>

                        <Box
                            sx={{
                                display: 'inline-flex',
                                borderRadius: '4px', // typical MUI chip border radius
                                border: '1px solid',
                                borderColor: 'primary.main',
                                height: 35, // typical chip height
                                width: '100%',
                            }}
                        >

                            <Select
                                sx={{'& fieldset': { border: 'none' }, width: '100%', backgroundColor: 'white'}}
                                size='small'
                                value={book4Accordion1}
                                onChange={handleOnChangeBook}
                            >
                                <MenuItem key={0} value={0}>請選擇聖經卷</MenuItem>
                                {bookList.map(bookListItem => (
                                    <MenuItem key={ bookListItem.Number } value={ bookListItem.Number }>
                                        ({ bookListItem.Number }) { bookListItem.Chinese_Name }【{ bookListItem.Chinese_Code }】
                                    </MenuItem>
                                ))}
                            </Select>     

                        </Box>

                    </Grid>

                {/* </Grid> */}

                {bookChapter2.book > 0 &&

                    <span>

                        <Grid size={12}>

                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    borderRadius: '4px', // typical MUI chip border radius
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    height: 35, // typical chip height
                                    width: '100%',
                                }}
                            >

                                <Select
                                    sx={{ '& fieldset': { border: 'none' }, width: '100%', backgroundColor: 'white' }}        
                                    size='small'
                                    value={chapter4Accordion1}
                                    onChange={handleOnChangeChapter}
                                >
                                    {bookChapterList2.map(bookChapterListItem => (
                                        <MenuItem key={bookChapterListItem.chapter} value={bookChapterListItem.chapter}>
                                        {getChapterChineseName(bookChapterListItem)}
                                        </MenuItem>
                                    ))}
                                </Select>         

                            </Box>

                        </Grid>

                        <Grid size={12}>

                            <Box
                                sx={{
                                    display: 'inline-flex',
                                    borderRadius: '4px', // typical MUI chip border radius
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    height: 35, // typical chip height
                                    width: '100%',
                                }}
                            >

                                <Select
                                    //size='small'
                                    // value={verse2}
                                    // onChange={handleOnChangeVerse}
                                    // input={<InputBase />}
                                    // fullWidth 
                                    //sx={{ width: '93%' }}                                      
                                    MenuProps={{
                                        PaperProps: {
                                        sx: {
                                            maxWidth: '100%', // Set fixed width for the dropdown menu
                                            overflow: 'auto', // Prevent horizontal scrolling
                                        },
                                        },
                                    }}
                                    sx={{ '& fieldset': { border: 'none' }, width: '100%', backgroundColor: 'white' }}        
                                    size='small'
                                    value={verse4Accordion1}
                                    onChange={handleOnChangeVerse}                                    
                                    //sx={{ '& fieldset': { border: 'none' }, width: { xs: '86%', md: '92%' }, backgroundColor: 'white', borderRadius: '4px 0px 0px 4px' }}
                                >
                                    {verseList4Accordion1.map((verseListItem, index) => (
                                        <MenuItem 
                                            key={index+1} 
                                            value={index+1}
                                            sx={{
                                                whiteSpace: 'normal', // Allow text wrapping
                                                wordWrap: 'break-word', // Break long words
                                                maxWidth: '100%', // Match the dropdown width
                                                overflow: 'auto',
                                            }}                                            
                                        >
                                            {index+1} {verseListItem}
                                        </MenuItem>
                                    ))}
                                </Select>        

                            </Box>

                        </Grid>                        

                        <Grid container justifyContent="center">

                            <IconButton
                                sx={{
                                    borderRadius: 1,
                                    width: 'auto',
                                    margin: 1,
                                }}
                                onClick={() => handleOnClickVerseAdd(book4Accordion1, chapter4Accordion1, verse4Accordion1, verseList4Accordion1[verse4Accordion1-1])}
                            >
                                <CheckIcon sx={{ color: 'white' }} />
                            </IconButton>                             
                            
                        </Grid>

                        {loading4Home && <ClipLoader1 />}

                    </span>                   

                }

            </AccordionDetails>

        </Accordion>

    )

}